import gsap from 'gsap'

export class ImageDezoom {
  constructor({ container }) {
    this.container = container

    this.init()
  }

  init() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.container,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true
      }
    })

    tl.fromTo(this.container, {
      scale: 1.2
    }, {
      scale: 1
    })
  }
}

export default function createImageDezoom(config) {
  return new ImageDezoom(config)
}
